import { SmartsheetLinkedService } from 'app/model/linkedservice/smartsheet.linkedservice';
import { LinkedServiceAdapter } from './linkedservice.adapter';
import { AdapterRegistry, IModel, Metamodel } from 'shell-models-lib';
import { Model } from '../../backendmodel';
import { parameterizablePasswordOrAKVtoSecretBase, parameterizableSecretBaseToModel } from './azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SmartsheetLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                apiToken: 'secret'
            },
            parameters: '*'
        }
    }
})
export class SmartsheetLinkedServiceAdapter extends LinkedServiceAdapter<SmartsheetLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => SmartsheetLinkedService {
        return SmartsheetLinkedService;
    }

    protected model(): IModel {
        return SmartsheetLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: SmartsheetLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.SmartsheetLinkedService;
        properties.type = Metamodel.modelFor(SmartsheetLinkedService).name;
        properties.typeProperties = {
            apiToken: parameterizablePasswordOrAKVtoSecretBase(linkedService, SmartsheetLinkedService.API_TOKEN, this.context)
        };
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: SmartsheetLinkedService): Promise<SmartsheetLinkedService> {
        const properties = linkedServiceResource.properties as Model.SmartsheetLinkedService;
        const typeProperties = properties.typeProperties;
        parameterizableSecretBaseToModel(linkedService, SmartsheetLinkedService.API_TOKEN, typeProperties.apiToken, this.context);
        return linkedService;
    }
}
